// thunk.js
import {
  fetchDeleteLocationFailure,
  fetchDeleteLocationSuccess,
} from "./reducer";

import { toast } from "react-toastify";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { DELETE_LOCATION } from "../../constants/constants";
import { getAllLocation } from "../GetLocation/thunk";

export const deleteLocation = (id, setLoading) => (dispatch) => {
  setLoading(true);

  determineBaseUrlAndPerformApiCall(
    DELETE_LOCATION(id),
    "DELETE",
  )
    .then((response) => {
      if (!response.error) {
        dispatch(getAllLocation(setLoading));
        dispatch(fetchDeleteLocationSuccess(response));

        setLoading(false);
        toast.success("Location Deleted Successfully");
      }

      if (response.error) {
        dispatch(fetchDeleteLocationFailure(response.error.message));

        setLoading(false);
        toast.error(response.error.message);
      }
    })
    .catch((errorResp) => {
      dispatch(
        fetchDeleteLocationFailure(
          errorResp?.message || "Something went wrong",
        ),
      );

      setLoading(false);
      toast.error(errorResp?.message || "Something went wrong");
    });
};